export function ReadOnlyOnboardingNotice() {
  return (
    <section
      className="rounded-lg border bg-white p-6 text-center dark:bg-slate-900"
      data-testid="onboarding-read-only-notice"
      aria-labelledby="read-only-heading"
    >
      <h2 id="read-only-heading" className="text-lg font-semibold">
        Tenant setup
      </h2>
      <p className="mt-2 text-sm text-slate-600 dark:text-slate-300">
        CRM setup is managed by your tenant administrators. Please reach out to
        them if you need changes made to onboarding.
      </p>
    </section>
  );
}
